module.exports = __webpack_public_path__ + "static/media/ponte.54ba1db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/ponte.png
// module id = 681
// module chunks = 0